import { create } from 'zustand';

/**
 * Zustand store for Recovery Resources (ISO 22301 Compliant)
 * Manages personnel, equipment, technology, etc. with time-based recovery requirements
 */
export const useRecoveryResourcesStore = create((set, get) => ({
    // State
    resources: [],
    loading: false,
    error: null,
    success: null, // For tracking operation success

    // Pagination & Params
    pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 1
    },
    params: {
        search: '',
        sortBy: 'name',
        sortOrder: 'asc'
    },

    // Global Modal State
    isFormOpen: false,
    isCreating: false,
    isEditing: false,
    deleteDialogOpen: false,
    selectedItem: null,

    // Actions
    setResources: (resources) => set({ resources }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSuccess: (success) => set({ success }),

    setPagination: (pagination) => set(state => ({
        pagination: { ...state.pagination, ...pagination }
    })),

    setParams: (newParams) => set(state => ({
        params: { ...state.params, ...newParams }
    })),

    openForm: (item = null) => set({
        isFormOpen: true,
        selectedItem: item,
        isCreating: !item,
        isEditing: !!item
    }),

    closeForm: () => set({
        isFormOpen: false,
        selectedItem: null,
        isCreating: false,
        isEditing: false
    }),

    openDeleteDialog: (item) => set({ deleteDialogOpen: true, selectedItem: item }),
    closeDeleteDialog: () => set({ deleteDialogOpen: false, selectedItem: null }),

    // Initialize from crisis object (Legacy/Fallback)
    initializeFromCrisis: (crisis) => {
        if (crisis?.recoveryResources) {
            set({ resources: crisis.recoveryResources });
        } else {
            set({ resources: [] });
        }
    },

    clearStore: () => set({
        resources: [],
        error: null,
        success: null,
        pagination: { page: 1, pageSize: 10, total: 0, totalPages: 1 },
        params: { search: '', sortBy: 'name', sortOrder: 'asc' }
    })
}));
